import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  idLote: number;
}

export function ModalSucessoCriarLote({ show, idLote }: IProps) {
  const handleClose = () => {
    window.location.reload();
  };
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Lote adicionado"
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Lote de pagamento criado com sucesso!
        <br />
        <strong>ID lote: {idLote}</strong>
      </ModalBody>
    </ModalCustom>
  );
}
